import { portalFeatureServiceDefinition } from "@esportal/esportal-feature-app-root/packages/feature-app/src/portal-service/portal-service";
import { oneformActionsFeatureServiceDefinition } from "vw-oneform-feature-app/src/feature-service/es-oneform-actions-feature-service";

export const definitions = [
  portalFeatureServiceDefinition,
  oneformActionsFeatureServiceDefinition
];